import { useCallback } from 'react';

import { useAxiosWithAPI } from '../../../../common/hooks/useAxiosWithAPI';

type ValidateImageQualityResponse = {
  isValid: boolean;
  error?: {
    code: string;
  };
};

export default function useValidateImageQuality() {
  const axios = useAxiosWithAPI();

  const validateImageQuality = useCallback(
    async (fileName: string) => {
      const { data } = await axios.post<ValidateImageQualityResponse>(
        '/company-verification/validate-image-quality',
        {
          fileName,
        }
      );

      return data;
    },
    [axios]
  );

  return validateImageQuality;
}
